export const socialMediaRouteNames = {
  default: 'social_media-v2',
}
